// @need-translate
import {TextTKey} from '../../../type';
import {MSG_ITEM_NOT_SALE, MSG_UNKNOWN_ERROR} from './constants';
import {ApiStatusCodeVo} from './vo/enums/ApiStatusCodeVo.enum';

export const API_STATUS_MESSAGE_MAP: {[key: number]: TextTKey} = {
  [ApiStatusCodeVo.Success]: {
    text: '성공',
    textTKey: 'api_common_success',
  },
  [ApiStatusCodeVo.NotAuthorized]: {
    text: '권한이 없습니다.',
    textTKey: 'api_user_authorize_not_found',
  },
  [ApiStatusCodeVo.UserNotFound]: {
    text: '사용자 정보를 찾을 수 없습니다. 다시 로그인해주세요',
    textTKey: 'api_user_not_found',
  },
  [ApiStatusCodeVo.NotPurchased]: {
    text: '구매한 상품이 아닙니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.ItemNotSales]: {
    text: MSG_ITEM_NOT_SALE,
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.TodayGiftExpired]: {
    text: '선물이 만료되었습니다.',
    textTKey: 'api_reward_gift_expired',
  },
  [ApiStatusCodeVo.TodayGiftNotTargetUser]: {
    text: '선물 대상자가 아닙니다.',
    textTKey: 'api_reward_gift_invalid_target',
  },
  [ApiStatusCodeVo.TodayGiftAlreadyReceived]: {
    text: '이미 받은 선물입니다.',
    textTKey: 'api_reward_gift_already_taken',
  },
  [ApiStatusCodeVo.TodayGiftDataWriteFail]: {
    text: '선물 정보를 기록하는데 실패했습니다.',
    textTKey: 'api_reward_gift_data_write_fail',
  },
  [ApiStatusCodeVo.ReceiveGiftLimitExceed]: {
    text: '선물 받을 수 있는 횟수를 초과했습니다.',
    textTKey: 'api_reward_gift_limit_over',
  },
  [ApiStatusCodeVo.TicketNotEnough]: {
    text: '구매가 필요한 콘텐츠입니다.\n이용권 충전 후 다시 시도해주세요.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.CashNotEnough]: {
    text: '캐시가 부족합니다',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodDeviceLimitOver]: {
    text: '이용 가능한 기기 대수가 초과되었습니다.\n해제할 기기를 선택해 주세요.\n(한 개의 ID당 5대의 기기 등록 가능)',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodPingFailed]: {
    text: '다른 기기에서 동일한 아이디로 재생하여 재생이 종료됩니다.\n재생은 한대의 기기로 제한됩니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodDeviceChangeLimitOver]: {
    text: '기기 변경 가능 횟수를 초과했습니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodNotRegisteredDevice]: {
    text: '등록되지 않은 기기입니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodInvalidDevice]: {
    text: '유효하지 않은 기기 정보입니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.WaitForPreviousRequest]: {
    text: '이전 요청을 처리중입니다. 잠시만 기다려주세요.',
    textTKey: 'alert_message_still_working',
  },
  [ApiStatusCodeVo.ItemAlreadyPurchased]: {
    text: '이미 구매한 항목입니다',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.TicketInfoInvalid]: {
    text: '회차 구매 정보가 유효하지 않습니다.\n잠시 후 다시 시도해주세요.',
    textTKey: 'api_ticket_info_invalid',
  },
  [ApiStatusCodeVo.ServerMaintenance]: {
    text: '서버 점검 중입니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodLicenseAuthorizationFalse]: {
    text: '사용자인증에 실패하였습니다',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodLicenseInvalidSingleId]: {
    text: '선택한 상품이 존재하지않습니다',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodLicenseOverRentDuration]: {
    text: '선택한 상품의 대여기간이 만료되었습니다',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodLicenseInvalidPayHistory]: {
    text: '선택한 상품의 구매이력이 존재하지않습니다',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodLicenseOverMaxMultiDevice]: {
    text: '한 계정에 등록할수있는 최대기기수를 초과하여 재생할수없습니다',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodInvalidCountry]: {
    text: '저작권상의 이유로 해당 국가에서는 이용이 제한됩니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodInvalidProxyIpType]: {
    text: '프록시로 접속할 경우 VOD 서비스를 사용할 수 없습니다',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodNoRightToPlay]: {
    text: '대여 기간 만료 등의 이유로 이용 권한이 없는 콘텐츠입니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.VodMobileOnly]: {
    text: '해당 상품은 모바일전용 상품입니다. PC에서 재생할 수 없습니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.UnknownError]: {
    text: MSG_UNKNOWN_ERROR,
    textTKey: 'api_common_server_error_3',
  },
  [ApiStatusCodeVo.AuthInfoRequestOver]: {
    text: '입력하신 정보와 일치하는 실명인증정보가 존재하지 않습니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.AuthInfoDifferentPrevCi]: {
    text: '본인 정보가 불일치하여 본인인증이 불가합니다.\n본인 명의의 휴대폰을 통해서만 인증이 가능합니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.AuthInfoTimeOver]: {
    text: '연령인증 가능 시간이 초과되었습니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.AuthInfoUserCancel]: {
    text: '연령인증이 취소되었습니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.AuthInfoUnder14]: {
    text: '만14세 미만은 본인 확인을 제공하지 않습니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.AuthInfoFailedThreeTimes]: {
    text: '입력하신 인증번호가 올바르지 않습니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.ItemAccessRestrictionCountryDenied]: {
    text: '해당 국가에서는 감상할 수 없는 작품입니다.',
    textTKey: 'api_content_access_denied_country',
  },
  [ApiStatusCodeVo.InvalidEmailAccountOrPassword]: {
    text: '계정 혹은 비밀번호가 일치하지 않습니다.',
    textTKey: 'api_user_email_or_password_not_match',
  },
  [ApiStatusCodeVo.ShowRecaptcha]: {
    text: 'reCAPTCHA 검증 후 로그인을 진행해주세요.',
    textTKey: 'login_email_recaptcha_toast_uncheck',
  },
  [ApiStatusCodeVo.EmailVerifyLimitExceeded]: {
    text: '인증 코드 발송 횟수를 초과했습니다.\n보안을 위해 잠시 후 다시 시도해 주세요.',
    textTKey: 'api_user_email_verify_limit_exceeded',
  },
  [ApiStatusCodeVo.EmailLoginBlocked]: {
    text: '로그인 시도가 여러 번 실패하여 10분간 로그인이 제한됩니다.',
    textTKey: 'login_email_alert_temporary_locked',
  },
};
